import { Layout } from "antd";
import { MainTemplate } from "../../components/templates";
import React from "react";
import { Routes, Route } from "react-router-dom";
import { useIsMobile } from "../../hooks/useIsMobile";

export const MainContent: React.FC = () => {
  const isMobile = useIsMobile();

  return (
    <Layout.Content
      style={{
        margin: isMobile ? "0 8px" : "0 16px",
        // Space for the fixed bottom navigation on mobile.
        paddingBottom: isMobile ? 74 : 16,
      }}
    >
      <Routes>
        <Route path="/:name?/:id?" element={<MainTemplate />} />
      </Routes>
    </Layout.Content>
  );
};
